import React from 'react';
import { WhatsappShareButton } from 'react-share';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SvgIcon from '../../SvgIcon';
import { socialShare } from '../../../actions';

function WhatsAppButtonShare(props) {
  const { url = 'https://www.givemyview.com', quote = '', slugId = '', actions } = props;
  const { socialShare: socialShareAction } = actions;
  return (
    <WhatsappShareButton
      url={url}
      quote={quote}
      className='c-social__link'
      onClick={() => {
        socialShareAction(slugId);
      }}
    >
      <span className='c-social__label'>Whatsapp</span>
      <SvgIcon icon='whatsapp' />
    </WhatsappShareButton>
  );
}

WhatsAppButtonShare.propTypes = {
  url: PropTypes.string.isRequired,
  quote: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      socialShare,
    },
    dispatch,
  ),
});

export default connect(null, mapDispatchToProps)(WhatsAppButtonShare);
